import { string } from "yup";
import {
  MAX_COMPANY_NAME_LENGTH,
  MAX_COMPANY_WEBSITE_LENGTH,
  validationSchema,
} from "component-library/src/components/Organisms/ContactPerformerPopUp/validationSchema";
import {
  TFunctionDeprecated,
  buildErrorMsg,
  buildMaxErrorMessage,
} from "component-library";
import { performerContactFallbackTranslations } from "component-library/src/components/Organisms/ContactPerformerPopUp/fallbackTranslations";

export const agentContactValidationSchema = (t: TFunctionDeprecated) => {
  const { companyName, companyWebsiteSocialMedia, maxLengthMessage, required } =
    performerContactFallbackTranslations;

  const overrides = {
    companyName: string()
      .nullable()
      .max(
        MAX_COMPANY_NAME_LENGTH,
        buildMaxErrorMessage(
          maxLengthMessage,
          companyName,
          MAX_COMPANY_NAME_LENGTH
        )
      )
      .required(buildErrorMsg(required, companyName)),
    companyWebsite: string()
      .nullable()
      .max(
        MAX_COMPANY_WEBSITE_LENGTH,
        buildMaxErrorMessage(
          maxLengthMessage,
          companyWebsiteSocialMedia,
          MAX_COMPANY_WEBSITE_LENGTH
        )
      )
      .required(buildErrorMsg(required, companyWebsiteSocialMedia)),
  };

  return validationSchema(t, overrides);
};
